import type { TFunction } from "i18next";
import type { UpdateUnavailable, WorkflowEdit, WorkflowEditChoice } from "../../../api/content/versionDecoders";

/**
 * F33's two named actions for an edited Workflow (ADR-0033 D4, built provisionally,
 * awaiting acceptance): "Update <W> to 1.3.0" makes a new version of the same Workflow;
 * "Save as a new Workflow derived from <W> 1.2.0" makes a new one at 1.0.0. The server
 * decides which is the default and whether updating is possible. Pure.
 */

export interface WorkflowEditAction {
  readonly edit: WorkflowEdit;
  readonly primary: boolean;
  /** Why the action can't be taken, or `null` when it can. */
  readonly unavailable: UpdateUnavailable | null;
  readonly text: string;
}

/** Update first, then derive; the default is the primary one. */
export function workflowEditActions(t: TFunction, choice: WorkflowEditChoice, workflowName: string): readonly WorkflowEditAction[] {
  const update = choice.updated === null ? t("versions.edit.updateUnlabelled", { workflow: workflowName }) : t("versions.edit.update", { workflow: workflowName, version: choice.updated });
  const derive = choice.current === null ? t("versions.edit.deriveUnlabelled", { workflow: workflowName }) : t("versions.edit.derive", { workflow: workflowName, version: choice.current });
  return [
    { edit: "update", primary: choice.defaultEdit === "update" && choice.updateUnavailable === null, unavailable: choice.updateUnavailable, text: update },
    { edit: "derive", primary: choice.defaultEdit === "derive" || choice.updateUnavailable !== null, unavailable: null, text: derive },
  ];
}
